import { z } from 'zod';

export const AddMemberValidator = z.object({
  given_name: z.string().min(1, {
    message: 'Please enter first name.',
  }),
  family_name: z.string().min(1, {
    message: 'Please enter last name.',
  }),
  email: z
    .string()
    .email({
      message: 'Please enter a valid email address.',
    })
    .min(1, {
      message: 'Please enter email.',
    }),
  phone_number: z.string().min(1, {
    message: 'Please enter phone number.',
  }),
  birthdate: z.date(),
  gender: z.string().min(1, {
    message: 'Please enter gender.',
  }),
  height: z.string().min(1, {
    message: 'Please enter height.',
  }),
  weight: z.string().min(1, {
    message: 'Please enter weight.',
  }),
  height_unit: z.string().min(1, {
    message: 'Please select height unit.',
  }),
  weight_unit: z.string().min(1, {
    message: 'Please enter weight unit.',
  }),
});

export type AddMemberFormData = z.infer<typeof AddMemberValidator>;
